import AddKeywordsModal from './AddKeywordsModal.component';

export default AddKeywordsModal;
